import { createSelector } from 'reselect';

import { OrderAdditionalServiceGdsServiceServiceType, SeatType } from '@websky/graphql';
import { ServicePayload } from '../../../../Checkout/store/selectedServices/actions';
import { getSelectedSeats } from './selectedSeats/selectors';
import { getIsActiveDoubleSeat, getPassengersSelectedSeats } from './passengers/selectors';
import { getSelectedSegmentRows } from './seatMap/selectors';
import { getSelectedPassengerFilters } from './selectedPassengersFilters/selectors';
import { getRowsByGroupWithStates } from '../lib/getRowsByGroupWithStates';
import { splitRowsByGroups } from '../lib/splitRowsByGroups';

export const getSelectedSeatsToSave = createSelector(
	getSelectedSeats,
	getPassengersSelectedSeats,
	(selectedSeats, passengersSelectedSeats) => {
		const seatsToSaveMap = new Map<string, ServicePayload[]>();

		passengersSelectedSeats.forEach(selectedSeat => {
			const segmentId = selectedSeat.segment.id;
			const passengerId = selectedSeat.passengerId.toString();
			const serviceId = selectedSeat.seat.number;

			const key = `${segmentId}/${passengerId}`;

			seatsToSaveMap.set(key, [
				...(seatsToSaveMap.get(key) ?? []),
				{
					segmentId,
					passengerId,
					serviceId,
					service: {
						segmentId,
						id: null,
						row: selectedSeat.row.toString(),
						letter: selectedSeat.letter,
						seatType: SeatType.common,
						type: OrderAdditionalServiceGdsServiceServiceType.Seat
					}
				}
			]);
		});

		selectedSeats.forEach(seat => {
			const segmentId = seat.segmentId.toString();
			const passengerId = seat.passengerId.toString();
			const serviceId = `${seat.row}${seat.letter}`;

			const key = `${segmentId}/${passengerId}`;

			seatsToSaveMap.set(key, [
				...(seatsToSaveMap.get(key) ?? []),
				{
					segmentId,
					passengerId,
					serviceId,
					service: {
						segmentId,
						id: null,
						row: seat.row.toString(),
						letter: seat.letter,
						seatType: SeatType.common,
						type: OrderAdditionalServiceGdsServiceServiceType.Seat
					}
				}
			]);
		});

		return [...seatsToSaveMap.values()].reduce(
			(seats, saveSeats) => [
				...seats,
				...saveSeats.map((seat, index) => {
					// The last entry is the new service
					if (index === saveSeats.length - 1) {
						return seat;
					}

					// Previously added services are removed
					return { ...seat, count: 0 };
				})
			],
			[]
		);
	}
);

export const getRowsByGroups = createSelector(getSelectedSegmentRows, splitRowsByGroups);

export const getRowsByGroupsDependsOnStates = createSelector(
	getRowsByGroups,
	getIsActiveDoubleSeat,
	getSelectedPassengerFilters,
	getRowsByGroupWithStates
);
